import { render } from "./CoinInfo.vue?vue&type=template&id=73c70d46&scoped=true"
import script from "./CoinInfo.vue?vue&type=script&lang=js"
export * from "./CoinInfo.vue?vue&type=script&lang=js"

import "./CoinInfo.vue?vue&type=style&index=0&id=73c70d46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c70d46"]])

export default __exports__